(() => {
    if (window.dmCartOverlayInertReady) return;
    window.dmCartOverlayInertReady = true;

    const panel = document.getElementById('halo-cart-sidebar');
    if (!panel || typeof MutationObserver === 'undefined') return;

    // Painel fechado fica fora da ordem de foco e da árvore de acessibilidade.
    const syncPanelState = () => {
        panel.toggleAttribute('inert', !document.body.classList.contains('cart-sidebar-show'));
    };

    syncPanelState();

    new MutationObserver(syncPanelState).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
    });
})();
